import React from 'react';
import CertificateGenerator from './CertificateGenerator';

import img from "../assets/img/Data6.png"

const Certification: React.FC = () => {
  return (
    <CertificateGenerator
      name="Shyam Sunder Tejpal"
      certificateNumber="CERT-2025-0919"
      imageUrl={img} 
    />
  );
};

export default Certification;